import type {State} from '../../constants/portaro.constants';
import {states} from '../../constants/portaro.constants';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {ActionResponse} from 'typings/portaro.be.types';
import type ActionRequestService from '../../services/action-request.service';
import type {Component} from '@kpsys/angularjs-register';

export interface KpActionRequestButtonBindings {
    path: string;
    cssClass?: string;
    requestMethod?: string;
    requestBody?: Record<string, unknown>;
    pathOnContext?: boolean;
    displayAsLink?: boolean;

    onSuccessCallback?(locals: { $actionResponse: ActionResponse }): void;
}

/**
 * @ngdoc component
 * @name kpActionRequestButton
 * @module portaro.components
 *
 * @param {string} path API path for request
 * @param {string=} cssClass bootstrap button type
 * @param {string=} requestMethod options 'delete','post' if it is not defined request method is 'get'
 * @param {string=} requestBody used only for 'post' method, generic json body
 * @param {boolean=} pathOnContext If `true` it prepend {@link constant:CONTEXT_PATH} before `path` attribute value.
 * @param {function()=} onSuccessCallback function which is called after successful request, possible to pass Response
 * @param {ActionResponse=} onSuccessCallback.$actionResponse full feedback of response .
 * @param {boolean=} displayAsLink Style of displaying.
 *
 * @description
 * This component is button which calls API according to input parameters of
 *
 * @deprecated use svelte version
 */
export default class KpActionRequestButtonComponent implements Component<KpActionRequestButtonBindings> {
    public static componentName = 'kpActionRequestButton';
    public templateUrl = require('./kp-action-request-button.tpl.ftl');
    public transclude = true;

    public bindings = {
        path: '@',
        cssClass: '@?',
        requestMethod: '@?',
        pathOnContext: '<?',
        requestBody: '<?',
        onSuccessCallback: '&?',
        displayAsLink: '<?'
    } as const;

    public controller = KpActionRequestButtonController;
}

/**
 * @deprecated use svelte version
 */
abstract class KpActionRequestButtonController implements KpActionRequestButtonBindings {
    public path: string;
    public cssClass: string;
    public requestMethod: string;
    public requestBody: Record<string, unknown>;
    public pathOnContext = true;
    public displayAsLink: boolean;

    public abstract onSuccessCallback(locals: { $actionResponse: ActionResponse }): void;

    public state: State;

    /*@ngInject*/
    constructor(private actionRequestService: ActionRequestService, private CONTEXT_PATH: string) {
    }

    @ngAsync()
    public async action(): Promise<void> {
        this.state = states.PROCESSING;

        try {
            const successCallback = this.onSuccessCallback ? ($actionResponse) => this.onSuccessCallback({$actionResponse}) : null;
            const path = this.pathOnContext ? this.CONTEXT_PATH + this.path : this.path;
            await this.actionRequestService.action(path, this.requestMethod, this.requestBody, successCallback);
        } finally {
            this.state = states.NORMAL;
        }
    }
}
